import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfService } from '../../config/conf.service';

export type WhatsAppTemplateStatus = 'IN_REVIEW' | 'APPROVED' | 'REJECTED' | 'PAUSED' | 'DISABLED';

export interface WhatsAppTemplate {
  templateKey: string;
  sourceType: 'SYSTEM' | 'CUSTOM';
  sourceTemplateId?: string | null;
  name: string;
  header?: string | null;
  body: string;
  footer?: string | null;
  status: WhatsAppTemplateStatus;
  rejectionReason?: string | null;
  category?: 'MARKETING' | 'UTILITY' | 'AUTHENTICATION' | null;
  lastSubmittedDate?: string | null;
  nextEditAllowedDate?: string | null;
}

/** Read-only: this service never creates, edits or deletes templates. */
@Injectable({ providedIn: 'root' })
export class WhatsAppTemplatesService {

  constructor(private http: HttpClient) { }

  getTemplates(contextId: string, contextIdType: string): Observable<WhatsAppTemplate[]> {
    const url = `${ConfService.apiUrl()}/rest/whatsAppTemplates/${encodeURIComponent(contextId)}/${encodeURIComponent(contextIdType)}`;
    return this.http.get<{ templates?: WhatsAppTemplate[] }>(url).pipe(map(response => response?.templates ?? []));
  }
}
